import { render, staticRenderFns } from "./PropertyNodes.vue?vue&type=template&id=16b1808e&"
import script from "./PropertyNodes.vue?vue&type=script&lang=js&"
export * from "./PropertyNodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports